export const selectStyles = {
  innerWrapper: 'p-0 w-fit [&>span]:text-base [&>span]:font-semibold',
  trigger:
    'after:hidden border-none hover:border-none !p-0 bg-warning justify-center items-center !rounded-[15px]',
  popoverContent: 'rounded-medium bg-warning',
  selectorIcon: 'h-[7px] w-[11px] static ml-[10px]',
}

export const stylesOption = {
  base: 'uppercase text-semibold focus:data-[selectable="true"]:bg-primary',
}
